import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Text from '@lightspeed/cirrus-text';
import { Switch } from '@lightspeed/flame/Switch';

import Skeleton from './Skeleton';

const SwipersEnabled = ({ isLoading, fieldName }) => {
  const renderedComponent = (
    <Card>
      <CardSection noSpacing>
        <div className="cr-flex cr-justify-between cr-items-center cr-pl-3 cr-pr-4 cr-pt-4 cr-pb-4">
          <Text bodySmall bold>
            Swipers Enabled
          </Text>
          <Field
            name={fieldName}
            render={({ field }) => (
              <Switch id={field.name} checked={field.value} onChange={field.onChange} />
            )}
          />
        </div>
      </CardSection>
    </Card>
  );

  return isLoading ? <Skeleton /> : renderedComponent;
};

SwipersEnabled.propTypes = {
  isLoading: PropTypes.bool,
  fieldName: PropTypes.string,
};

SwipersEnabled.defaultProps = {
  isLoading: true,
  fieldName: 'swipersEnabled',
};

export default SwipersEnabled;
